export const AUTH_ROUTE_PARAMS = {
  USER_ROLE: 'userRole',
};
